import CustomButton from "components/common/Button/CustomButton";
import ModalSkeleton from "components/Modals/ModalSkeleton";
import { apiGetRequest } from "helpers/Requests";
import React from "react";

import { toast } from "react-toastify";
import { URL_PARTICIPANT_DELETE_SINGLE_MEDICATION } from "store/services/URL";

const DeleteModal = (props) => {
  const {
    isUserGracePeriodOver,
    openDeleteModal,
    closeModal,
    index,
    remove,
    selectDeletedMedication,
    setDeleteLoader,
    deleteLoader,
  } = props;

  const handleDelete = async () => {
    // Check if medication has a UUID (saved medication) or if it's a new unsaved medication
    const medicationUuid = selectDeletedMedication?.item?.uuid || selectDeletedMedication?.uuid;
    const medicationId = selectDeletedMedication?.item?.id || selectDeletedMedication?.id;
    
    // If it's a new medication (no UUID), just remove it from the form
    if (!medicationUuid && !medicationId) {
      remove(index);
      closeModal();
      return;
    }

    // If it has a UUID, delete via API
    if (medicationUuid) {
      setDeleteLoader(true);

      try {
        const res = await apiGetRequest(
          `${URL_PARTICIPANT_DELETE_SINGLE_MEDICATION}/${medicationUuid}`
        );

        if (res.status === 200) {
          toast.success("Medication deleted successfully");
          remove(index);
          setDeleteLoader(false);
          closeModal();
        } else {
          toast.error("Unable to delete medication");
          setDeleteLoader(false);
        }
      } catch (err) {
        setDeleteLoader(false);
        toast.error(err.message || "Something went wrong");
      }
    } else {
      toast.error("Cannot delete medication: missing medication identifier");
    }
  };
  const modalFooter = () => (
    <>
      <CustomButton label='No, cancel changes' onClick={closeModal} />
      <CustomButton
        showLoading={deleteLoader}
        isDisabled={deleteLoader || isUserGracePeriodOver}
        label='Yes, delete Medication'
        clickHandler={handleDelete}
        variant='danger'
      />
    </>
  );
  return (
    <>
      <ModalSkeleton
        modalFooter={modalFooter()}
        isOpen={openDeleteModal}
        closeModal={closeModal}
        cssClass='w-[40%]'
        title={"Delete Medication"}
      >
        <div>
          <p className='text-gray-700 flex justify-center'>
            Are you sure you want to delete this medication?
          </p>
        </div>
      </ModalSkeleton>
    </>
  );
};

export default DeleteModal;
